import NetworkState from '../../../core/types/network';
import { ReduxAction, DispatchFunc } from '../../../core/types/redux';
import { RequestInfo, TestStatus } from '../result/types';

export enum ResultDetailsActionConstants {
  INITIALIZE = '@@resultDetails/INITIALIZE',
  RESULT_DETAILS_REQUEST = '@@resultDetails/RESULT_DETAILS_REQUEST',
  RESULT_DETAILS_SET = '@@resultDetails/RESULT_DETAILS_SET',
  SELECT_GROUP_TAB_SET = '@@resultDetails/SELECT_GROUP_TAB_SET',
  TEST_LIST_POPUP_OPEN = '@@resultDetails/TEST_LIST_POPUP_OPEN',
  TEST_LIST_POPUP_CLOSE = '@@resultDetails/TEST_LIST_POPUP_CLOSE',
  ATTACH_LIST_POPUP_OPEN = '@@resultDetails/ATTACH_LIST_POPUP_OPEN',
  ATTACH_LIST_POPUP_CLOSE = '@@resultDetails/ATTACH_LIST_POPUP_CLOSE',
  ATTACH_LIST_REQUEST = '@@resultDetails/ATTACH_LIST_REQUEST',
  ATTACH_LIST_SET = '@@resultDetails/ATTACH_LIST_SET',
}

export interface ResultDetailsInfo {
  requestInfo: RequestInfo;
  resultInfo: ResultInfo[];
}

export interface AttachInfo {
  id: string;
  name: string;
  fileType: string;
  filePath: string;
}

export interface ResultParamInfo {
  resultDetailId: string;
  param: string;
  lastResult?: string;
  result?: string;
  repeat?: boolean;
  unit?: string;
  rangeType?: 'digit' | 'word';
  rangePanicLow?: number;
  rangeLow?: number;
  rangeHigh?: number;
  rangePanicHigh?: number;
  rangeNormal?: string;
  rangeWordingEn?: string;
  rangeWordingTh?: string;
  paramType: 'single' | 'head' | 'multi';
  isAttach?: boolean;
}

export interface ResultInfo {
  id: string;
  testName: string;
  form: FormInfo;
  status: TestStatus;
  params: ResultParamInfo[];
}

export interface FormInfo {
  formId: number;
  formCode: string;
  formName: string;
  formFile: string;
  langIndex: string;
}

export interface RequestResultDetailsArgs {
  id: string;
}

export interface SetResultDetailsArgs {
  resultDetails?: ResultDetailsInfo;
  error?: Error;
}

export interface RequestAttachListArgs {
  resultDetailId: string;
}

export interface SetAttachListArgs {
  result?: AttachInfo[];
  error?: Error;
}

export interface SelectGroupTabArgs {
  tab: FormInfo;
}

export interface OpenAttachPopupArgs {
  resultDetailId: string;
}

export type ResultDetailsAction<TArgs> = ReduxAction<TArgs, ResultDetailsActionConstants>;
export type ResultDetailsDispatchFunc<TArgs> = DispatchFunc<TArgs, ResultDetailsActionConstants>;

export interface ResultDetailsState {
  networkStates: {
    resultDetailsRequest: NetworkState;
    attachListRequest: NetworkState;
  };
  isInitialized: boolean;
  resultDetails?: ResultDetailsInfo;
  groupSelected: FormInfo;
  attachListPopup: {
    isOpen: boolean;
    resultDetailId?: string;
  };
  attachList?: AttachInfo[];
  testListPopup: {
    isOpen: boolean;
  };
}
